export default __webpack_public_path__ + "static/media/Harness of Insanity.a8114696.jpg";